import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { LoginResponseModel } from '@shared/models/auth/login-response.model';
import { OauthResponseModel } from '@shared/models/oauth/oauth-response.model';
import { StorageService } from '@shared/services/storage.service';
@Injectable()
export class HttpInterceptorService implements HttpInterceptor {
  constructor(private router: Router, private storageService: StorageService,) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
): Observable<HttpEvent<any>> {

    let authorization="";
    // location-owner login start
    const urlParams = new URLSearchParams(window.location.search);
    const currentType = urlParams.get('type');
    if (currentType === 'location-owner') {
        const clientToken = localStorage.getItem('ClientAccessToken');
        if (clientToken) {
            const parsedToken = JSON.parse(clientToken);
            if (parsedToken && parsedToken.expires_in > Date.now()) {
                authorization = `Bearer ${parsedToken.access_token}`;
            }
        }
    } 
    // end login sales
    else{
    if (req.url.indexOf('oauth') != -1) {
        //do nothing
    } else if (req.url.indexOf('api/v1/filter') != -1
    || req.url.indexOf('api/auth') != -1) {
        const token:any= this.storageService.getClientAccessToken();
        if (token && token.expires_in > Date.now())
        authorization =`Bearer ${this.storageService.getClientAccessToken().access_token}`;
    } else if (req.url.indexOf('api/v1') != -1) {
        const token = this.storageService.getAccessToken();
        if (token && token.expires_in > Date.now())
        authorization = `Bearer ${this.storageService.getAccessToken().access_token}`
        else this.router.navigate(['/']);
    }
    const _token = localStorage.getItem('AccessToken');

    if(_token!==null){
        authorization = `Bearer ${JSON.parse(_token).access_token}`;
    }
    const token = this.storageService.getAccessToken();
    if (token && token.expires_in < Date.now()) {
        authorization = '';
    }
}
    const headers = new HttpHeaders({
        platform: 'WEB',
        'app-version': '1.00',
        accept: 'application/json',
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods':
        'GET, POST, OPTIONS, PUT, PATCH, DELETE',
        'Access-Control-Allow-Headers': 'X-Requested-With,content-type',
        'Authorization':authorization,
        "X-Client-Platform" : "Web-App",
        "X-Client-Version": "2.0.0",
        "ngrok-skip-browser-warning": "69420"
    });
    if(!req.headers.has('Content-Type')){
        headers.set('Content-Type','application/json')
    }
    else{
        headers.set('accept','*/*')
    }
    const clonedRequest = req.clone({ headers });

    return next.handle(clonedRequest);
}
}
